var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.4 11.2c.4.3.9.3 1.2 0l10.1-8.1c-.2 0-.4-.1-.7-.1H2c-.3 0-.5.1-.7.1l10.1 8.1z","key":0}),React.createElement("path",{"d":"M13.9 12.8c-.6.4-1.2.7-1.9.7s-1.3-.2-1.9-.7L0 4.7V19c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V5v-.3l-10.1 8.1z","key":1})]);
}

Mail.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Mail;

Mail.default = Mail;
